import React from "react";
import Icon from "@mdi/react";
import { Location } from "../../../interfaces/country.interface";
import { Select } from "antd";
import { mdiFilterVariant } from "@mdi/js";


const LocationDropdown = (
  props: {
    locations:Location[];
    initialValue:string;
    selectLocation;
  }
) => {
  const { locations, initialValue } = props;

  return (
    <div className="location-dropdown">
      <Select
          className="location-filter"
          suffixIcon={<Icon path={mdiFilterVariant} size="18px" />}
          variant="borderless"
          defaultValue="china"
          value={initialValue}
          options={locations.map((location) => ({label: location.name, value: location.id}))}
          dropdownStyle={{padding: "15px 20px", borderRadius: "20px", boxShadow: "0px 3.08px 16.47px 0px #00000040"}}
          optionRender={(option) => (
            <div className="location-filter_option"> {option.label} </div>
          )}
          onChange={props.selectLocation}
        />
    </div>
  )
}

export default LocationDropdown;